import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";
import {ComponentController} from "../../infrastructure/controllers/component-controller";
import {UserSelectionsManager} from "../managers/user-selections.manager";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {BreadcrumbsClickEvent} from "../models/events/breadcrumbs-click.event";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";

export class BreadcrumbsClickHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.onBreadcrumbsClick;
  controller: ComponentController;
  userSelectionsManager: UserSelectionsManager;

  static injectables = [...ActionHandler.injectables, AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BreadcrumbsClickEvent;
  }
}
